import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  wrapPicker: {
    width: '880px',
    paddingRight: '10px',
    marginTop: '-60px',
    [Theme.breakpoints.down('lg')]: {
      width: '850px',
    },
  },
  wrapCalendarPicker: {
    width: '880px',
    position: 'relative',
    overflow: 'visible !important',
    [Theme.breakpoints.down('lg')]: {
      width: '850px',
    },
  },
  datepickerHeader: {
    padding: '10px 30px 10px 30px',
  },
  datepickerHeaderInputs: {
    width: '50%',
  },
  datepickerHeaderInput: {
    width: '320px',
  },
  datepickerBody: {
    padding: '0 30px 10px 30px',
  },
  datepickerMessages: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    fontFamily: Theme.typography.base.regular,
    fontSize: '14px',
    lineHeight: '17px',
    marginTop: '30px',
    color: Theme.palette.gray[750],
  },
  datepickerFooter: {
    padding: '15px 30px 25px 30px',
    [Theme.breakpoints.up('md')]: {
      padding: '10px 30px 20px 30px',
    },
    [Theme.breakpoints.up('lg')]: {
      padding: '20px 30px 30px 30px',
    },
  },
  datepickerCalendar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
  },
  resetButton: {
    padding: '0 !important',
    margin: '0 20px 0 0 !important',
    height: '50px',
  },
  underscore: {
    width: Theme.typography.size[4],
    height: Theme.typography.pxToRem(3),
    background: '#061556',
    borderRadius: '10px',
    marginLeft: Theme.typography.pxToRem(7.5),
    marginRight: '8px',
    marginTop: '7px',
  },
}));

export default useStyles;
